import { render, staticRenderFns } from "./_icons.vue?vue&type=template&id=bbfd6f8a&"
import script from "./_icons.vue?vue&type=script&lang=ts&"
export * from "./_icons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbfd6f8a')) {
      api.createRecord('bbfd6f8a', component.options)
    } else {
      api.reload('bbfd6f8a', component.options)
    }
    module.hot.accept("./_icons.vue?vue&type=template&id=bbfd6f8a&", function () {
      api.rerender('bbfd6f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_showcase/atoms/_icons.vue"
export default component.exports